import FallbackLoader from '@async-components/FallbackLoader';

export { keySeen, keyClicked, keyMaxSeen } from './common';

export default FallbackLoader(() => import(/* webpackChunkName: "async-BannerSurvey" */'./index'));
